module.exports = __webpack_public_path__ + "static/media/success.ecdc9452.gif";